require('../../modules/es6.math.log10');
module.exports = require('../../modules/_core').Math.log10;
